export const getBounds = (points) => {

  let minx = 100; let miny = 100;
  let maxx = -100; let maxy = -100;

  for (let point of points) {
    if (point.x < minx) minx = point.x;
    if (point.y < miny) miny = point.y;
    if (point.x > maxx) maxx = point.x;
    if (point.y > maxy) maxy = point.y;
  }

  minx *= 10;
  miny *= 10;
  maxx *= 10;
  maxy *= 10;

  return { minx, miny, maxx, maxy };
}

export const getRandomInt = (min, max) => {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
}
